import {Box, HStack, StyleProps, Text, VStack} from '@chakra-ui/react';
import {useLocation} from 'react-router-dom';
import {ItemCatalogue2StateMarketplace} from 'ff-common';
import {imageOptimisee} from '@/domains/mediatheque/optimisation';
import {InnerVignetteArticleVStack} from '@/domains/mediatheque/VignetteArticleVStack';
import {ArticleCodesDisplay} from '../components/ArticleCodesDisplay';
import NiceModal from '@ebay/nice-modal-react';
import {ApercuProduitModale} from '@/components/Modale/ApercuProduitModale';
import {HitItemCatalogue} from 'api-types/ffconnect';

export const ArticleBlockMarketplace: React.FC<
  {
    itemState: ItemCatalogue2StateMarketplace;
  } & StyleProps
> = ({itemState, ...props}) => {
  const location = useLocation();

  const {code, libelle, image_principale_url, marketplace_id} = itemState.data;
  const imageUrl = imageOptimisee(image_principale_url, 70);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    // Construire un hit marketplace pour la modale d'aperçu — seuls code, libelle_commercial,
    // vignette_url et marketplace_id sont utilisés par la modale pour l'affichage immédiat
    const hit: HitItemCatalogue = {
      code,
      ref_tiers: code,
      libelle_commercial: libelle,
      vignette_url: image_principale_url,
      marketplace_id,
      cat_marketplace: [],
      cat_std: [],
      cat_web: [],
      pays_d_origine: [],
    };
    NiceModal.show(ApercuProduitModale, {hit, location});
  };

  return (
    <HStack
      alignItems='start'
      cursor='pointer'
      onClick={handleClick}
      mr='2em'
      {...props}
      position='relative'
    >
      <Box>
        <InnerVignetteArticleVStack imageUrl={imageUrl} />
      </Box>
      <VStack alignItems='start'>
        <ArticleCodesDisplay
          code_article={code}
          marketplace_id={marketplace_id}
        />
        <Text
          display={{base: 'none', md: 'block'}}
          fontWeight='600'
          lineHeight='16px'
          maxW='400px'
        >
          {libelle}
        </Text>
        <Text
          display={{base: 'block', md: 'none'}}
          fontWeight='600'
          lineHeight='16px'
        >
          {libelle}
        </Text>
      </VStack>
    </HStack>
  );
};
